// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.About {
    min-height: 100vh;
    display: block;
}

/* Organization / top section - black background with white text */
.About-org {
    /* make the "Who we are"/About organization section full-bleed so the
       background reaches the viewport edges (removes white borders above/below)
       Inner container (.About-org-inner) keeps the horizontal padding for content. */
    background: #000;
    color: #fff;
    padding: 64px 0; /* vertical spacing only on the section */
    position: relative;
    /* removed the full-bleed viewport offset (left:50% / -50vw) because the
       page uses a persistent left sidebar/margin; that technique caused the
       About section to shift off to the side. Keep the section full width of
       its container so it respects the layout. */
    width: 100%;
    box-shadow: none;
    border: none;
}
.About-org-inner {
    max-width: 1100px;
    margin: 0 auto;
    /* keep horizontal padding inside the inner container so content doesn't touch edges */
    padding-left: 36px;
    padding-right: 36px;
}

/* two-column layout inside About: logo on the left, text on the right */

.About-org-grid {
    display: flex;
    align-items: flex-start;
    gap: 20px;
}

.About-text {
    flex: 1 1 auto;
    /* align the logo with the text baseline so it sits inline with the heading */
    align-items: baseline;
    gap: 8px;
    /* nudge the whole heading (text + logo) upward so it sits closer to the top of the section */
    margin-top: -50px;
}

.About-logo-inline-right {
    /* configure vertical offset with a variable so it's easy to tweak */
    --about-logo-y: -5px;
    width: 260px; /* scaled-up logo */
    height: auto;
    display: inline-block;
    transform: translateY(var(--about-logo-y));
}

.About-text h1 {
    margin: 0 0 64px 0; /* larger gap between header+logo row and following text */
    font-size: 2.25rem;
    color: #fff;
}

/* layout the About heading and inline logo */
.About-heading-row {
    display: inline-flex;
    align-items: center;
    gap: 16px;
}

.About-heading-row h1 {
    margin: 0; /* ensure no extra top/bottom margin interferes with vertical alignment */
}

.About-text p {
    margin: 24px 0 0 0; /* push the body text down, separate from the heading+logo */
    max-width: 900px;
    line-height: 1.6;
    color: rgba(255,255,255,0.92);
}

/* Team section - split into left (photos) and right (white intro pane) */
.Team-section {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
}
.Team-left {
    flex: 1 1 420px;
    background: #fff; /* switch to white background */
    color: #000;
    padding: 48px 28px;
}
.Team-left h2 {
    margin-top: 0;
}

/* Central heading spanning both columns */
.Team-heading {
    text-align: left;
    margin: 0 0 20px 0; /* align with Team-right-inner text and add bottom spacing */
    font-size: 2.6rem; /* larger section heading */
    line-height: 1.05;
}
.Team-members {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-top: 16px;
}
.Team-member {
    display: flex;
    flex-direction: column; /* stack photo above text */
    gap: 12px;
    align-items: center;
    text-align: center; /* center the name/position text */
}
.Team-photo {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid rgba(0,0,0,0.06);
}
.Team-member-meta {
    display: flex;
    flex-direction: column;
    align-items: center; /* center meta content under photo */
}
.Team-member-name {
    margin: 0;
    font-size: 1.05rem;
}
.Team-position {
    margin: 2px 0 0 0;
    font-size: 0.9rem;
    color: #333;
}

/* New three-column grid for team members with director centered */
.Team-members-grid {
    flex: 1 1 640px;
    display: grid;
    grid-template-columns: 1fr 320px 1fr;
    gap: 0px;
    background: #fff;
    /* collapsed by default: hide members area until it appears */
    max-height: 0;
    overflow: hidden;
    padding: 0 28px 0; /* collapse padding as well */
    align-items: start;
    transition: max-height 520ms ease, padding 520ms ease;
}

.Team-members-grid.appear {
    /* large enough to contain the grid when expanded; using a generous value */
    max-height: 1400px;
    padding: 88px 28px 48px;
}
.Team-column {
    display: flex;
    flex-direction: column;
    gap: 18px;
}
.Team-column--center {
    display: flex;
    align-items: center;
    justify-content: center;
}
.Team-member--director {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 12px;
    max-width: 320px;
    /* lift the director slightly so they visually sit above flank members */
    transform: translateY(100px);
}
.Team-photo--director {
    width: 240px;
    height: 240px;
    border-radius: 50%;
    object-fit: cover;
    border: 4px solid rgba(0,0,0,0.06);
}
.Team-member-desc {
    margin-top: 8px;
    color: #444;
    font-size: 0.95rem;
}

/* place the director in the center column when using the three-column grid */
.Team-member--director-grid {
    grid-column: 2 / 3;
}

/* members grid slots (explicit placement) */
.slot-top-left { grid-column: 1; grid-row: 1; }
.slot-top-center { grid-column: 2; grid-row: 1; }
.slot-top-right { grid-column: 3; grid-row: 1; }
.slot-bottom-left { grid-column: 1; grid-row: 2; }
.slot-bottom-center { grid-column: 2; grid-row: 2; }
.slot-bottom-right { grid-column: 3; grid-row: 2; }

/* members rows container: spans the full grid and lays out items in rows */
.Team-members-rows {
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: center;
    padding-top: 18px;
}

/* Slightly lower the top-left and top-right flank members so the director visually sits higher */
.slot-top-left .Team-member {
    /* shift right and down a bit so Christopher sits slightly lower and more inward */
    transform: translate(50px, 12px);
}
.slot-top-right .Team-member {
    /* move the right flank inward and slightly lower so Shoi sits closer to the director */
    transform: translate(-50px, 12px);
}

/* shift the bottom-left member (Nevan) inward toward center */
.slot-bottom-left .Team-member {
    transform: translateX(50px);
}

/* shift the bottom-right member (Eric) inward toward center */
.slot-bottom-right .Team-member {
    transform: translateX(-50px);
}

/* Appear/disappear behavior controlled by JS toggling the .appear class on .Team-members-grid
   Default: hidden (opacity 0). When .appear is present set opacity to 1. Use transition-delay
   to stagger so the director (center) appears first. We avoid changing transforms here to not
   conflict with positioning offsets already in use. */
.Team-members-grid .member-slot .Team-member {
    opacity: 0;
    transition: opacity 360ms ease;
}
.Team-members-grid.appear .member-slot .Team-member {
    opacity: 1;
}

/* Stagger: director (slot-top-center) first */
.Team-members-grid.appear .member-slot.slot-top-center .Team-member { transition-delay: 0s; }
.Team-members-grid.appear .member-slot.slot-top-left .Team-member { transition-delay: 0.08s; }
.Team-members-grid.appear .member-slot.slot-top-right .Team-member { transition-delay: 0.08s; }
.Team-members-grid.appear .member-slot.slot-bottom-left .Team-member { transition-delay: 0.24s; }
.Team-members-grid.appear .member-slot.slot-bottom-center .Team-member { transition-delay: 0.16s; }
.Team-members-grid.appear .member-slot.slot-bottom-right .Team-member { transition-delay: 0.24s; }

/* Respect reduced-motion */
@media (prefers-reduced-motion: reduce) {
    .Team-members-grid .member-slot .Team-member,
    .Team-members-grid.appear .member-slot .Team-member {
        transition: none;
        opacity: 1;
    }
}

.Team-member--row {
    /* fixed card width so items form rows; adjusts responsively */
    width: 240px;
}

/* Director row (centered) */
.Team-director-row {
    display: flex;
    justify-content: center;
    padding: 28px 20px 8px;
    background: #fff;
}

/* Two-column members grid placed under the director */
.Team-members-grid-two {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
    padding: 24px 28px 48px;
    background: #fff;
}
.Team-column {
    display: flex;
    flex-direction: column;
    gap: 18px;
}

/* Slightly larger director photo already defined; center text */
.Team-member--director {
    text-align: center;
    align-items: center;
}

@media (max-width: 900px) {
    /* stack the two-column grid to a single column */
    .Team-members-grid-two {
        grid-template-columns: 1fr;
        padding: 16px 20px 28px;
    }
    .Team-director-row {
        padding: 18px 12px 6px;
    }
    /* reset director transform on small screens so stacking looks natural */
    .Team-column--center .Team-member--director {
        transform: none;
    }
}

.Team-right {
    flex: 1 1 420px;
    background: #fff;
    color: #000;
    /* increase left padding so the column content moves further to the right
       and add extra top padding to lower the heading/text vertically */
    padding: 88px 32px 48px 48px;
}
.Team-right-inner {
    max-width: 760px;
    /* stop centering so content hugs the left side of the section */
    margin: 0;
    /* reduce left padding so heading/text sit closer to the section edge */
    padding-left: 36px;
    padding-right: 12px;
    text-align: left; /* ensure text is left-aligned */
}
.Team-right h3 {
    margin-top: 0;
}
.Team-right p {
    line-height: 1.6;
    color: #111;
    font-size: 1.125rem; /* slightly larger body text for emphasis */
}

/* Responsive: scale down heading/text on small screens */
@media (max-width: 600px) {
    .Team-heading {
        font-size: 1.6rem;
    }
    .Team-right p {
        font-size: 1rem;
    }
}

/* Responsive: stack on small screens */
@media (max-width: 900px) {
    .Team-section {
        flex-direction: column;
    }
    .About-org-grid {
        flex-direction: column;
        text-align: center;
    }
    .About-logo {
        margin-bottom: 12px;
    }
    .About-logo {
        margin-left: 0; /* reset when stacked */
    }
    .About-logo-inline-right {
        /* mobile override: remove offset and set a smaller width */
        --about-logo-y: 0;
        transform: translateY(var(--about-logo-y)); /* reset transform on small screens */
        width: 96px; /* slightly larger on small screens for legibility */
    }
    /* reduce spacing on small screens so content doesn't appear too separated */
    .About-text p {
        margin-top: 16px;
    }
    .Team-left, .Team-right {
        flex: 1 1 100%;
        padding: 28px 20px;
    }
    .Team-members {
        flex-direction: row;
        flex-wrap: wrap;
    }
    .Team-member {
        width: calc(50% - 12px);
    }
    /* stack three-column grid into a single column on small screens */
    .Team-members-grid {
        display: block;
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        background: #fff;
    }
    .Team-column {
        width: 100%;
        margin-bottom: 18px;
    }
    .Team-column--center .Team-photo--director {
        width: 190px;
        height: 190px;
    }

    /* undo the desktop translate on small screens so cards stack naturally */
    .slot-top-left .Team-member,
    .slot-top-right .Team-member {
        transform: none;
    }
    /* reset director shift on small screens */
    .Team-member--director {
        transform: none;
    }

    /* reset horizontal shift for bottom-left on small screens */
    .slot-bottom-left .Team-member {
        transform: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/About.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,kEAAkE;AAClE;IACI;;qFAEiF;IACjF,gBAAgB;IAChB,WAAW;IACX,eAAe,EAAE,yCAAyC;IAC1D,kBAAkB;IAClB;;;iDAG6C;IAC7C,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,sFAAsF;IACtF,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,wEAAwE;;AAExE;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,6EAA6E;IAC7E,qBAAqB;IACrB,QAAQ;IACR,6FAA6F;IAC7F,iBAAiB;AACrB;;AAEA;IACI,oEAAoE;IACpE,oBAAoB;IACpB,YAAY,EAAE,mBAAmB;IACjC,YAAY;IACZ,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB,EAAE,0DAA0D;IAC9E,kBAAkB;IAClB,WAAW;AACf;;AAEA,6CAA6C;AAC7C;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,SAAS,EAAE,yEAAyE;AACxF;;AAEA;IACI,kBAAkB,EAAE,4DAA4D;IAChF,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA,yEAAyE;AACzE;IACI,aAAa;IACb,eAAe;IACf,MAAM;AACV;AACA;IACI,eAAe;IACf,gBAAgB,EAAE,+BAA+B;IACjD,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;;AAEA,0CAA0C;AAC1C;IACI,gBAAgB;IAChB,kBAAkB,EAAE,4DAA4D;IAChF,iBAAiB,EAAE,2BAA2B;IAC9C,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB,EAAE,2BAA2B;IACnD,SAAS;IACT,mBAAmB;IACnB,kBAAkB,EAAE,kCAAkC;AAC1D;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,oCAAoC;AAC7D;AACA;IACI,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA,kEAAkE;AAClE;IACI,eAAe;IACf,aAAa;IACb,oCAAoC;IACpC,QAAQ;IACR,gBAAgB;IAChB,6DAA6D;IAC7D,aAAa;IACb,gBAAgB;IAChB,iBAAiB,EAAE,6BAA6B;IAChD,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,2EAA2E;IAC3E,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,gBAAgB;IAChB,wEAAwE;IACxE,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kCAAkC;AACtC;AACA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA,6EAA6E;AAC7E;IACI,kBAAkB;AACtB;;AAEA,4CAA4C;AAC5C,iBAAiB,cAAc,EAAE,WAAW,EAAE;AAC9C,mBAAmB,cAAc,EAAE,WAAW,EAAE;AAChD,kBAAkB,cAAc,EAAE,WAAW,EAAE;AAC/C,oBAAoB,cAAc,EAAE,WAAW,EAAE;AACjD,sBAAsB,cAAc,EAAE,WAAW,EAAE;AACnD,qBAAqB,cAAc,EAAE,WAAW,EAAE;;AAElD,2EAA2E;AAC3E;IACI,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,QAAQ;IACR,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA,iGAAiG;AACjG;IACI,kFAAkF;IAClF,gCAAgC;AACpC;AACA;IACI,uFAAuF;IACvF,iCAAiC;AACrC;;AAEA,8DAA8D;AAC9D;IACI,2BAA2B;AAC/B;;AAEA,8DAA8D;AAC9D;IACI,4BAA4B;AAChC;;AAEA;;;sDAGsD;AACtD;IACI,UAAU;IACV,8BAA8B;AAClC;AACA;IACI,UAAU;AACd;;AAEA,8CAA8C;AAC9C,sEAAsE,oBAAoB,EAAE;AAC5F,oEAAoE,uBAAuB,EAAE;AAC7F,qEAAqE,uBAAuB,EAAE;AAC9F,uEAAuE,uBAAuB,EAAE;AAChG,yEAAyE,uBAAuB,EAAE;AAClG,wEAAwE,uBAAuB,EAAE;;AAEjG,2BAA2B;AAC3B;IACI;;QAEI,gBAAgB;QAChB,UAAU;IACd;AACJ;;AAEA;IACI,8DAA8D;IAC9D,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,sDAAsD;AACtD;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,gEAAgE;AAChE;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iDAAiD;IACjD;QACI,0BAA0B;QAC1B,uBAAuB;IAC3B;IACA;QACI,sBAAsB;IAC1B;IACA,wEAAwE;IACxE;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX;uEACmE;IACnE,4BAA4B;AAChC;AACA;IACI,gBAAgB;IAChB,gEAAgE;IAChE,SAAS;IACT,uEAAuE;IACvE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB,EAAE,gCAAgC;AACtD;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB,EAAE,2CAA2C;AACpE;;AAEA,yDAAyD;AACzD;IACI;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA,uCAAuC;AACvC;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,cAAc,EAAE,uBAAuB;IAC3C;IACA;QACI,2DAA2D;QAC3D,iBAAiB;QACjB,0CAA0C,EAAE,qCAAqC;QACjF,WAAW,EAAE,oDAAoD;IACrE;IACA,4EAA4E;IAC5E;QACI,gBAAgB;IACpB;IACA;QACI,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,uBAAuB;IAC3B;IACA,kEAAkE;IAClE;QACI,cAAc;QACd,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA,yEAAyE;IACzE;;QAEI,eAAe;IACnB;IACA,0CAA0C;IAC1C;QACI,eAAe;IACnB;;IAEA,4DAA4D;IAC5D;QACI,eAAe;IACnB;AACJ","sourcesContent":[".About {\n    min-height: 100vh;\n    display: block;\n}\n\n/* Organization / top section - black background with white text */\n.About-org {\n    /* make the \"Who we are\"/About organization section full-bleed so the\n       background reaches the viewport edges (removes white borders above/below)\n       Inner container (.About-org-inner) keeps the horizontal padding for content. */\n    background: #000;\n    color: #fff;\n    padding: 64px 0; /* vertical spacing only on the section */\n    position: relative;\n    /* removed the full-bleed viewport offset (left:50% / -50vw) because the\n       page uses a persistent left sidebar/margin; that technique caused the\n       About section to shift off to the side. Keep the section full width of\n       its container so it respects the layout. */\n    width: 100%;\n    box-shadow: none;\n    border: none;\n}\n.About-org-inner {\n    max-width: 1100px;\n    margin: 0 auto;\n    /* keep horizontal padding inside the inner container so content doesn't touch edges */\n    padding-left: 36px;\n    padding-right: 36px;\n}\n\n/* two-column layout inside About: logo on the left, text on the right */\n\n.About-org-grid {\n    display: flex;\n    align-items: flex-start;\n    gap: 20px;\n}\n\n.About-text {\n    flex: 1 1 auto;\n    /* align the logo with the text baseline so it sits inline with the heading */\n    align-items: baseline;\n    gap: 8px;\n    /* nudge the whole heading (text + logo) upward so it sits closer to the top of the section */\n    margin-top: -50px;\n}\n\n.About-logo-inline-right {\n    /* configure vertical offset with a variable so it's easy to tweak */\n    --about-logo-y: -5px;\n    width: 260px; /* scaled-up logo */\n    height: auto;\n    display: inline-block;\n    transform: translateY(var(--about-logo-y));\n}\n\n.About-text h1 {\n    margin: 0 0 64px 0; /* larger gap between header+logo row and following text */\n    font-size: 2.25rem;\n    color: #fff;\n}\n\n/* layout the About heading and inline logo */\n.About-heading-row {\n    display: inline-flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.About-heading-row h1 {\n    margin: 0; /* ensure no extra top/bottom margin interferes with vertical alignment */\n}\n\n.About-text p {\n    margin: 24px 0 0 0; /* push the body text down, separate from the heading+logo */\n    max-width: 900px;\n    line-height: 1.6;\n    color: rgba(255,255,255,0.92);\n}\n\n/* Team section - split into left (photos) and right (white intro pane) */\n.Team-section {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0;\n}\n.Team-left {\n    flex: 1 1 420px;\n    background: #fff; /* switch to white background */\n    color: #000;\n    padding: 48px 28px;\n}\n.Team-left h2 {\n    margin-top: 0;\n}\n\n/* Central heading spanning both columns */\n.Team-heading {\n    text-align: left;\n    margin: 0 0 20px 0; /* align with Team-right-inner text and add bottom spacing */\n    font-size: 2.6rem; /* larger section heading */\n    line-height: 1.05;\n}\n.Team-members {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    margin-top: 16px;\n}\n.Team-member {\n    display: flex;\n    flex-direction: column; /* stack photo above text */\n    gap: 12px;\n    align-items: center;\n    text-align: center; /* center the name/position text */\n}\n.Team-photo {\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 3px solid rgba(0,0,0,0.06);\n}\n.Team-member-meta {\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* center meta content under photo */\n}\n.Team-member-name {\n    margin: 0;\n    font-size: 1.05rem;\n}\n.Team-position {\n    margin: 2px 0 0 0;\n    font-size: 0.9rem;\n    color: #333;\n}\n\n/* New three-column grid for team members with director centered */\n.Team-members-grid {\n    flex: 1 1 640px;\n    display: grid;\n    grid-template-columns: 1fr 320px 1fr;\n    gap: 0px;\n    background: #fff;\n    /* collapsed by default: hide members area until it appears */\n    max-height: 0;\n    overflow: hidden;\n    padding: 0 28px 0; /* collapse padding as well */\n    align-items: start;\n    transition: max-height 520ms ease, padding 520ms ease;\n}\n\n.Team-members-grid.appear {\n    /* large enough to contain the grid when expanded; using a generous value */\n    max-height: 1400px;\n    padding: 88px 28px 48px;\n}\n.Team-column {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n.Team-column--center {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.Team-member--director {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 12px;\n    max-width: 320px;\n    /* lift the director slightly so they visually sit above flank members */\n    transform: translateY(100px);\n}\n.Team-photo--director {\n    width: 240px;\n    height: 240px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 4px solid rgba(0,0,0,0.06);\n}\n.Team-member-desc {\n    margin-top: 8px;\n    color: #444;\n    font-size: 0.95rem;\n}\n\n/* place the director in the center column when using the three-column grid */\n.Team-member--director-grid {\n    grid-column: 2 / 3;\n}\n\n/* members grid slots (explicit placement) */\n.slot-top-left { grid-column: 1; grid-row: 1; }\n.slot-top-center { grid-column: 2; grid-row: 1; }\n.slot-top-right { grid-column: 3; grid-row: 1; }\n.slot-bottom-left { grid-column: 1; grid-row: 2; }\n.slot-bottom-center { grid-column: 2; grid-row: 2; }\n.slot-bottom-right { grid-column: 3; grid-row: 2; }\n\n/* members rows container: spans the full grid and lays out items in rows */\n.Team-members-rows {\n    grid-column: 1 / -1;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    justify-content: center;\n    padding-top: 18px;\n}\n\n/* Slightly lower the top-left and top-right flank members so the director visually sits higher */\n.slot-top-left .Team-member {\n    /* shift right and down a bit so Christopher sits slightly lower and more inward */\n    transform: translate(50px, 12px);\n}\n.slot-top-right .Team-member {\n    /* move the right flank inward and slightly lower so Shoi sits closer to the director */\n    transform: translate(-50px, 12px);\n}\n\n/* shift the bottom-left member (Nevan) inward toward center */\n.slot-bottom-left .Team-member {\n    transform: translateX(50px);\n}\n\n/* shift the bottom-right member (Eric) inward toward center */\n.slot-bottom-right .Team-member {\n    transform: translateX(-50px);\n}\n\n/* Appear/disappear behavior controlled by JS toggling the .appear class on .Team-members-grid\n   Default: hidden (opacity 0). When .appear is present set opacity to 1. Use transition-delay\n   to stagger so the director (center) appears first. We avoid changing transforms here to not\n   conflict with positioning offsets already in use. */\n.Team-members-grid .member-slot .Team-member {\n    opacity: 0;\n    transition: opacity 360ms ease;\n}\n.Team-members-grid.appear .member-slot .Team-member {\n    opacity: 1;\n}\n\n/* Stagger: director (slot-top-center) first */\n.Team-members-grid.appear .member-slot.slot-top-center .Team-member { transition-delay: 0s; }\n.Team-members-grid.appear .member-slot.slot-top-left .Team-member { transition-delay: 0.08s; }\n.Team-members-grid.appear .member-slot.slot-top-right .Team-member { transition-delay: 0.08s; }\n.Team-members-grid.appear .member-slot.slot-bottom-left .Team-member { transition-delay: 0.24s; }\n.Team-members-grid.appear .member-slot.slot-bottom-center .Team-member { transition-delay: 0.16s; }\n.Team-members-grid.appear .member-slot.slot-bottom-right .Team-member { transition-delay: 0.24s; }\n\n/* Respect reduced-motion */\n@media (prefers-reduced-motion: reduce) {\n    .Team-members-grid .member-slot .Team-member,\n    .Team-members-grid.appear .member-slot .Team-member {\n        transition: none;\n        opacity: 1;\n    }\n}\n\n.Team-member--row {\n    /* fixed card width so items form rows; adjusts responsively */\n    width: 240px;\n}\n\n/* Director row (centered) */\n.Team-director-row {\n    display: flex;\n    justify-content: center;\n    padding: 28px 20px 8px;\n    background: #fff;\n}\n\n/* Two-column members grid placed under the director */\n.Team-members-grid-two {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 6px;\n    padding: 24px 28px 48px;\n    background: #fff;\n}\n.Team-column {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n}\n\n/* Slightly larger director photo already defined; center text */\n.Team-member--director {\n    text-align: center;\n    align-items: center;\n}\n\n@media (max-width: 900px) {\n    /* stack the two-column grid to a single column */\n    .Team-members-grid-two {\n        grid-template-columns: 1fr;\n        padding: 16px 20px 28px;\n    }\n    .Team-director-row {\n        padding: 18px 12px 6px;\n    }\n    /* reset director transform on small screens so stacking looks natural */\n    .Team-column--center .Team-member--director {\n        transform: none;\n    }\n}\n\n.Team-right {\n    flex: 1 1 420px;\n    background: #fff;\n    color: #000;\n    /* increase left padding so the column content moves further to the right\n       and add extra top padding to lower the heading/text vertically */\n    padding: 88px 32px 48px 48px;\n}\n.Team-right-inner {\n    max-width: 760px;\n    /* stop centering so content hugs the left side of the section */\n    margin: 0;\n    /* reduce left padding so heading/text sit closer to the section edge */\n    padding-left: 36px;\n    padding-right: 12px;\n    text-align: left; /* ensure text is left-aligned */\n}\n.Team-right h3 {\n    margin-top: 0;\n}\n.Team-right p {\n    line-height: 1.6;\n    color: #111;\n    font-size: 1.125rem; /* slightly larger body text for emphasis */\n}\n\n/* Responsive: scale down heading/text on small screens */\n@media (max-width: 600px) {\n    .Team-heading {\n        font-size: 1.6rem;\n    }\n    .Team-right p {\n        font-size: 1rem;\n    }\n}\n\n/* Responsive: stack on small screens */\n@media (max-width: 900px) {\n    .Team-section {\n        flex-direction: column;\n    }\n    .About-org-grid {\n        flex-direction: column;\n        text-align: center;\n    }\n    .About-logo {\n        margin-bottom: 12px;\n    }\n    .About-logo {\n        margin-left: 0; /* reset when stacked */\n    }\n    .About-logo-inline-right {\n        /* mobile override: remove offset and set a smaller width */\n        --about-logo-y: 0;\n        transform: translateY(var(--about-logo-y)); /* reset transform on small screens */\n        width: 96px; /* slightly larger on small screens for legibility */\n    }\n    /* reduce spacing on small screens so content doesn't appear too separated */\n    .About-text p {\n        margin-top: 16px;\n    }\n    .Team-left, .Team-right {\n        flex: 1 1 100%;\n        padding: 28px 20px;\n    }\n    .Team-members {\n        flex-direction: row;\n        flex-wrap: wrap;\n    }\n    .Team-member {\n        width: calc(50% - 12px);\n    }\n    /* stack three-column grid into a single column on small screens */\n    .Team-members-grid {\n        display: block;\n        width: 100%;\n        padding: 20px;\n        box-sizing: border-box;\n        background: #fff;\n    }\n    .Team-column {\n        width: 100%;\n        margin-bottom: 18px;\n    }\n    .Team-column--center .Team-photo--director {\n        width: 190px;\n        height: 190px;\n    }\n\n    /* undo the desktop translate on small screens so cards stack naturally */\n    .slot-top-left .Team-member,\n    .slot-top-right .Team-member {\n        transform: none;\n    }\n    /* reset director shift on small screens */\n    .Team-member--director {\n        transform: none;\n    }\n\n    /* reset horizontal shift for bottom-left on small screens */\n    .slot-bottom-left .Team-member {\n        transform: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
